module.exports = __webpack_public_path__ + "img/archived.fea2e3d6.svg";